import { Abstract, Modify } from '../commons/commons.types';
import { Group, GroupLight } from './groups.types';
import { Site } from './sites.types';

export type SafetyKeyLight = {
  id: number | null;
  code: string | null;
  active: boolean | null;
  locked: boolean | null;
};

export enum LogoutCauseEnum {
  NONE = 'NONE',
  PASSWORD_REINITIALIZED = 'PASSWORD_REINITIALIZED',
  USER_UPDATED = 'USER_UPDATED',
  USER_DELETED = 'USER_DELETED',
}

export enum AuthSource {
  LDAP,
  JDBC,
}

export type User = {
  id: number;
  firstName: string;
  name: string;
  email: string;
  login: string;
  password: string | null;
  active: boolean;
  deactivationDate: string | null;
  sites: Site[];
  activeSite: Site | null;
  groups: GroupLight[];
  activeGroup: Group | null;
  safetyKey: SafetyKeyLight | null;
  authSource: AuthSource;
} & Abstract;

export type UserLight = {
  id: number;
  name: string | null;
  firstName: string | null;
  login: string | null;
  email: string | null;
};

export type NormalizedUser = Modify<
  User,
  {
    sites: string[];
    activeSite: string | null;
  }
>;

export interface AuthentSettings {
  id: number;
  passwordComplexity: boolean;
  passwordDuration: number;
  adminPasswordDuration: number;
  activationDuration: number;
  displayMode: DisplayModeEnum;
}

export interface Token {
  authorizations: number[];
  exp: number;
  id: string;
  name: string;
  sub: string;
  displayMode?: string;
}

export enum DisplayModeEnum {
  MULTI_TABS_WITH_COCKPIT = 'MULTI_TABS_WITH_COCKPIT',
  TWO_TABS = 'TWO_TABS',
  MONO_TAB = 'MONO_TAB',
  NOT_SET = 'NOT_SET',
}
